export const isDevEnvironment = () => {
  return process.env.NODE_ENV === 'development';
};
